//@flow
import React from "react"
import Loader from "../UI/Loader"
import { refreshTokens, accessToken } from "./tokenHelpers"
import { Link } from "react-router-dom"
import type { Match } from "react-router-dom"

type Props = {
  match: Match,
  history: { replace: Function, push: Function }
}

type State = {
  loading: boolean,
  error: boolean
}

class Authenticator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { loading: false, error: false }
  }

  componentDidMount() {
    this.attemptRefresh()
  }

  componentDidUpdate(prevProps: Props) {
    const token = this.props.match.params.token
    if (token && prevProps.match.params.token !== token) {
      this.attemptRefresh()
    }
  }

  async attemptRefresh() {
    const { match: { params: { token } }, history: { replace } } = this.props
    if (token) {
      this.setState(() => ({ loading: true }))
      await refreshTokens(token)
      this.setState(() => ({ loading: false }))
      const newToken = await accessToken()
      if (newToken) {
        replace("/admin")
      }
    } else {
      this.setState(() => ({ loading: false, error: true }))
    }
  }

  render() {
    const { loading, error } = this.state
    return (
      <Loader loading={loading}>
        {error || !loading ? (
          <p>
            The sign in link you used has expired.{" "}
            <Link to="/">Click here to continue.</Link>
          </p>
        ) : null}
      </Loader>
    )
  }
}

export default Authenticator



// WEBPACK FOOTER //
// ./src/Auth/Authenticator.js